/**
 * Every locale the site ships. `code` is the dictionary filename, `slug` the URL
 * prefix segment, `htmlLang` and `dir` are applied to <html>; `ogLocale` is the
 * Open Graph locale used for the social preview.
 */
export const LOCALES = [
  { code: 'en',     slug: 'en',     label: 'English',             htmlLang: 'en',     dir: 'ltr', ogLocale: 'en_US' },
  { code: 'de',     slug: 'de',     label: 'Deutsch',             htmlLang: 'de',     dir: 'ltr', ogLocale: 'de_DE' },
  { code: 'fr',     slug: 'fr',     label: 'Français',            htmlLang: 'fr',     dir: 'ltr', ogLocale: 'fr_FR' },
  { code: 'es-ES',  slug: 'es-es',  label: 'Español (ES)',        htmlLang: 'es-ES',  dir: 'ltr', ogLocale: 'es_ES' },
  { code: 'es-419', slug: 'es-419', label: 'Español (LatAm)',     htmlLang: 'es-419', dir: 'ltr', ogLocale: 'es_LA' },
  { code: 'pt-PT',  slug: 'pt-pt',  label: 'Português (PT)',      htmlLang: 'pt-PT',  dir: 'ltr', ogLocale: 'pt_PT' },
  { code: 'pt-BR',  slug: 'pt-br',  label: 'Português (BR)',      htmlLang: 'pt-BR',  dir: 'ltr', ogLocale: 'pt_BR' },
  { code: 'ar',     slug: 'ar',     label: 'العربية',             htmlLang: 'ar',     dir: 'rtl', ogLocale: 'ar_AR' },
  { code: 'ru',     slug: 'ru',     label: 'Русский',             htmlLang: 'ru',     dir: 'ltr', ogLocale: 'ru_RU' },
  { code: 'uk',     slug: 'uk',     label: 'Українська',          htmlLang: 'uk',     dir: 'ltr', ogLocale: 'uk_UA' },
  { code: 'pl',     slug: 'pl',     label: 'Polski',              htmlLang: 'pl',     dir: 'ltr', ogLocale: 'pl_PL' },
  { code: 'cs',     slug: 'cs',     label: 'Čeština',             htmlLang: 'cs',     dir: 'ltr', ogLocale: 'cs_CZ' },
  { code: 'sk',     slug: 'sk',     label: 'Slovenčina',          htmlLang: 'sk',     dir: 'ltr', ogLocale: 'sk_SK' },
  { code: 'sl',     slug: 'sl',     label: 'Slovenščina',         htmlLang: 'sl',     dir: 'ltr', ogLocale: 'sl_SI' },
  { code: 'hu',     slug: 'hu',     label: 'Magyar',              htmlLang: 'hu',     dir: 'ltr', ogLocale: 'hu_HU' },
  { code: 'da',     slug: 'da',     label: 'Dansk',               htmlLang: 'da',     dir: 'ltr', ogLocale: 'da_DK' },
  { code: 'fi',     slug: 'fi',     label: 'Suomi',               htmlLang: 'fi',     dir: 'ltr', ogLocale: 'fi_FI' },
  { code: 'sv',     slug: 'sv',     label: 'Svenska',             htmlLang: 'sv',     dir: 'ltr', ogLocale: 'sv_SE' },
  { code: 'no',     slug: 'no',     label: 'Norsk',               htmlLang: 'no',     dir: 'ltr', ogLocale: 'nb_NO' },
  { code: 'ko',     slug: 'ko',     label: '한국어',              htmlLang: 'ko',     dir: 'ltr', ogLocale: 'ko_KR' },
  { code: 'zh',     slug: 'zh',     label: '中文（简体）',         htmlLang: 'zh-CN',  dir: 'ltr', ogLocale: 'zh_CN' },
];

export const DEFAULT_LOCALE = 'en';

const BY_CODE = new Map(LOCALES.map((locale) => [locale.code, locale]));

export const getLocale = (code) => BY_CODE.get(code) ?? BY_CODE.get(DEFAULT_LOCALE);

export const isSupportedLocale = (code) => BY_CODE.has(code);
